import { createFileRoute, notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import apollo from "@/helpers/apollo";
import { cloudinaryImageUrl } from "@/helpers/cloudinary-url";
import { gameUrl } from "@/helpers/games";
import Experience from "@/pages/experience";
import { QUERY } from "@/pages/experience/graphql";
import type { GameDataType, GameVariablesType } from "@/pages/experience/types";

const fetchExperience = createServerFn({ method: "GET" })
  .inputValidator((data: { gameId: string }) => data)
  .handler(async ({ data }) => {
    const client = apollo();
    const response = await client.query<GameDataType, GameVariablesType>({
      fetchPolicy: "no-cache",
      query: QUERY,
      variables: { id: data.gameId, isUser: false },
    });

    if (!response.data) {
      throw notFound();
    }

    return { game: response.data.game };
  });

export const Route = createFileRoute("/experience/$gameId/$escapeId")({
  component: ExperiencePage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    const { game } = loaderData;
    const [firstImage] = game.gameimageSet || [];
    const image = firstImage?.imageId
      ? cloudinaryImageUrl(firstImage.imageId)
      : `${process.env.APP_URL}/images/share.jpg`;
    const url = process.env.APP_URL + gameUrl(game);

    return {
      links: [{ href: url, rel: "canonical" }],
      meta: [
        { title: "Review" },
        { content: image, property: "og:image" },
        { content: "Review", property: "og:title" },
        { content: "website", property: "og:type" },
        { content: url, property: "og:url" },
        { content: "summary_large_image", name: "twitter:card" },
        { content: "@mortyapp", name: "twitter:site" },
      ],
    };
  },
  loader: ({ params }) => fetchExperience({ data: { gameId: params.gameId } }),
});

function ExperiencePage() {
  const { game } = Route.useLoaderData();
  return <Experience game={game} />;
}
